import { render, staticRenderFns } from "./newConference.vue?vue&type=template&id=64eb0bc3&scoped=true&lang=pug&"
import script from "./newConference.vue?vue&type=script&lang=js&"
export * from "./newConference.vue?vue&type=script&lang=js&"
import style0 from "./newConference.vue?vue&type=style&index=0&id=64eb0bc3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64eb0bc3",
  null
  
)

export default component.exports